import { render, staticRenderFns } from "./ConceptPatternDialog.vue?vue&type=template&id=3254c520&scoped=true"
import script from "./ConceptPatternDialog.vue?vue&type=script&lang=js"
export * from "./ConceptPatternDialog.vue?vue&type=script&lang=js"
import style0 from "./ConceptPatternDialog.vue?vue&type=style&index=0&id=3254c520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../production-parity-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3254c520",
  null
  
)

export default component.exports